









































































































































import Vue from "vue";
// import Component from 'vue-class-component'
import { Component, Prop } from "vue-property-decorator";
import { Variation, Expression, ExpressionType } from "../../types/NewResults";
import { timerString } from "@/utils";
// The @Component decorator indicates the class is a Vue component
@Component({
  // All component options are allowed in here
  template: '<button @click="onClick">Click!</button>'
})
export default class EmotionGraph extends Vue {
  @Prop() private videoFileURL!: string;

  @Prop() private expression!: Expression;
  private segmentLength: Number = 0;
  private maxwidth = 344 - 77;
  private timerString = timerString;
  private created() {
    console.log(this.expression);
    this.segmentLength =
      this.maxwidth /
      this.expression.overTime[this.expression.overTime.length - 1].endTime;
    console.log(this.segmentLength);
  }
  private getEndTime(): Number {
    if (this.expression.overTime.length == 0) {
      return 0;
    }
    return (
      this.expression.overTime[this.expression.overTime.length - 1].endTime /
      1000
    );
  }
  private getHeight(expression: ExpressionType) {
    switch (expression) {
      case ExpressionType.Positive:
        return 1;
        break;
      case ExpressionType.Neutral:
        return 26;
        break;
      default:
        return 51;
        break;
    }
  }
  private getColor(expressions: ExpressionType) {
    switch (expressions) {
      case ExpressionType.Negative:
        return "#F74657";
        break;
      case ExpressionType.Neutral:
        return "#FFCC00";
        break;
      case ExpressionType.Positive:
        return "#38D17A";
        break;
      default:
        return "transparent";
        break;
    }
  }
}
